<div class="ts-attachments">

  <button class="ts-attachments-drop" type="button" (click)="selectFile($event, inputFile)">
    <div class="ts-attachments-drop-ico">
      <i class="bi bi-cloud-arrow-up"></i>
    </div>
    <form [formGroup]="myForm" class="ts-attachments-drop-text">
      <label for="filechose_button" class="primary">Upload a file or drag and drop</label>
      <input
        [accept]="acceptFiles.join(',')"
        #inputFile
        formControlName="file"
        id="filechose_button"
        type="file"
        (change)="onFileChange($event)" />
      <span class="hint">PDF, JPG, PNG up to 3MB</span>
    </form>
  </button>

  <div class="ts-attachments-loader" *ngIf="loading">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <div class="ts-attachments-empty" *ngIf="!loading && !attachmentsArr?.length">
    <div class="ico"><i class="bi bi-paperclip"></i></div>
    <h3>No attachments yet</h3>
    <p>Drop files above or click the upload area to add them.</p>
  </div>

  <ul class="ts-attachments-list" *ngIf="attachmentsArr?.length">
    <li class="ts-attachment" *ngFor="let attachment of attachmentsArr">
      <div class="ts-attachment-thumb">
        <img *ngIf="!getFileIcon(attachment)" [src]="attachment.contents" alt="" />
        <img *ngIf="getFileIcon(attachment)" [src]="getFileIcon(attachment)" alt="" />
      </div>
      <div class="ts-attachment-meta">
        <span class="name">{{ attachment.originalName }}</span>
        <span class="when">Added on {{ dataSharedService.getFormatedDate(attachment.addedDate) }}</span>
      </div>
      <div class="ts-attachment-actions">
        <button type="button"
          class="icon-btn-sm"
          (click)="downloadDocument(attachment)"
          title="Download">
          <i class="bi bi-download"></i>
        </button>
        <button type="button"
          class="icon-btn-sm reject"
          (click)="deleteDocuments(attachment.uuid)"
          title="Delete">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </li>
  </ul>
</div>
